var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
//import { buildWall, updatedWall } from './wall-factory-3d';
import * as SharedStyle from '../../shared-style';
import * as Geometry from '../../utils/geometry';
import { GeometryUtils } from '../../utils/export';

var epsilon = 20;
var STYLE_TEXT = { textAnchor: 'middle' };
var STYLE_LINE = { stroke: SharedStyle.LINE_MESH_COLOR.selected };
var STYLE_RECT = { strokeWidth: 1, stroke: SharedStyle.PIPE_MESH_COLOR.unselected };
var STYLE_RECT_SELECTED = _extends({}, STYLE_RECT, { stroke: SharedStyle.PIPE_MESH_COLOR.selected });

export default function PipeFactoryGas(name, info, textures, diameter) {

  var pipeElement = {
    name: name,
    prototype: 'pipes',
    info: info,
    properties: {
      diameter: {
        label: "Diameter",
        type: "read-only",
        defaultValue: {
          length: diameter ? diameter : 0,
          unit: 'mm'
        }
      },
      // diameter: {
      //   label: "Diameter",
      //   type: "length-measure",
      //   defaultValue: {
      //     length: diameter ? diameter : 0,
      //     unit: 'cm'
      //   }
      // },

      // height: {
      //   label: 'height',
      //   type: 'length-measure',
      //   defaultValue: {
      //     length: 300,
      //   }
      // },
      thickness: {
        label: 'thickness',
        type: 'length-measure',
        defaultValue: {
          length: 5
        }
      },
      altitude: {
        label: "Altitude",
        type: "length-measure",
        defaultValue: {
          length: 0,
          unit: 'cm'
        }
      },
      // patternColor: {
      //   label: 'color',
      //   type: 'color',
      //   defaultValue: SharedStyle.PIPE_MESH_COLOR.unselected
      // },
      // text: {
      //   label: 'text',
      //   type: 'string',
      //   defaultValue: ''
      // },

      is_dashedLine: {
        label: 'underground',
        type: 'checkbox',
        defaultValue: false,
        values: {
          'none': false,
          'yes': true
        }
      }
    },

    render2D: function render2D(element, layer, scene) {
      var vertex0 = layer.vertices.get(element.vertices.get(0));
      var vertex1 = layer.vertices.get(element.vertices.get(1));

      var x1 = vertex0.x,
          y1 = vertex0.y;
      var x2 = vertex1.x,
          y2 = vertex1.y;

      if (x1 > x2) {
        x1 = vertex1.x;
        y1 = vertex1.y;
        x2 = vertex0.x;
        y2 = vertex0.y;
      }

      var length = GeometryUtils.pointsDistance(x1, y1, x2, y2);
      var thickness = element.getIn(['properties', 'thickness', 'length']);
      var half_thickness = thickness / 2;

      var fill = SharedStyle.PIPE_MESH_COLOR.unselected;
      var isDashed = element.properties.get('is_dashedLine');
      var dashArrayView = (4 * thickness).toString() + " " + (2 * thickness).toString();

      if (!isDashed) {
        return React.createElement(
          'g',
          null,
          React.createElement('rect', { x: -half_thickness, y: -half_thickness, rx: '5', ry: '5', width: length + thickness, height: thickness, style: STYLE_RECT_SELECTED, fill: fill })
        );
      } else {
        return React.createElement(
          'g',
          null,
          React.createElement('line', { x1: '0', y1: '0', x2: length, y2: '0', fill: fill, stroke: fill, strokeWidth: thickness, strokeDasharray: dashArrayView, strokeLinecap: 'round' })
        );
      }
    },

    render3D: function render3D(element, layer, scene) {
      var mesh = new Mesh();
      return Promise.resolve(mesh);
    }
  };

  return pipeElement;
}